export class Constants {
  public static DEFAULT_LANGUAGE = 'en';
  public static SYSTEM_LANGUAGES = ['en'];
}
